import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[toOnlyExclusiveNumber]'
})
export class OnlyExclusiveNumberDirective {

  private arrayRegex = /[^0-9]/g;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: KeyboardEvent) {
    const initalValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initalValue.replace(this.arrayRegex, '');
    if (initalValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
